module.exports = {"500111001":"龙岗街道","500111002":"棠香街道","500111003":"龙滩子街道","500111004":"双路街道","500111005":"通桥街道","500111006":"智凤街道","500111100":"龙水镇","500111102":"宝顶镇","500111103":"中敖镇","500111104":"三驱镇","500111105":"宝兴镇","500111106":"玉龙镇","500111107":"石马镇","500111108":"拾万镇","500111109":"回龙镇","500111110":"金山镇","500111111":"万古镇","500111112":"国梁镇","500111113":"雍溪镇","500111114":"珠溪镇","500111115":"龙石镇","500111116":"邮亭镇","500111117":"铁山镇","500111118":"高升镇","500111119":"季家镇","500111120":"古龙镇","500111121":"高坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500111.json
// module id = 2222
// module chunks = 0